export default __webpack_public_path__ + "static/zscaler-36e22ad2f1ece11d64f0d2d016700034.png";